export const successState = {
    Successful: true,
    Unsuccessful: false,
};

export const loginMethod = {
    BankID: "BankID",
    Username: "Username/Password",
};

export function pushLogin(successful, loginMethod) {
    const dataLayerObj = {
        event: "login",
        successful: successful,
        login_method: loginMethod,
    };
    window["dataLayer"].push(dataLayerObj);
}

export function pushActivation(successful) {
    const dataLayerObj = {
        event: "bankid_activation",
        successful: successful,
    };

    window["dataLayer"].push(dataLayerObj);
}

export function pushTestAccountCreation() {
    const dataLayerObj = {
        event: "create_trial_account"
    };

    window["dataLayer"].push(dataLayerObj);
}
